import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";
type FullPageLoaderProps = {
  isActive: boolean;
};
export const FullPageLoader = ({ isActive }: FullPageLoaderProps) => {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isActive}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
